<template lang="pug">
div
  .container
    dados-documento(
      :documento="documento"
    )

  el-row
    div.container(v-if="this.bytes != null")
      app-pdf-viewer(:bytes="bytes")

</template>

<script>
import AppPDFViewer from '@/components/AppPDFViewer'
import DadosDocumento from '@/screens/assinatura/components/DadosDocumento'

export default {
  components: {
    AppPdfViewer: AppPDFViewer,
    DadosDocumento
  },

  props: {
    documento: {
      type: Object,
      required: true
    },

    bytes: {
      type: ArrayBuffer,
      required: false
    }
  }
}

</script>

<style lang="scss" scoped>
.container {
  display: flex;
  height: 100%;
  flex-direction: column;
  padding: 10px;
}

.text-container >>> .label-divider {
  padding-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/components/VisualizarDocumentos.vue